var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AlertModalContainer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var opened = ref.opened;
var title = ref.title;
var text = ref.text;
var okLabel = ref.okLabel;
var close = ref.close;
return [(opened)?_c('BModal',{attrs:{"visible":"","centered":"","modal-class":"alert-box"},on:{"hidden":close,"close":close,"ok":close},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._v(_vm._s(title))]},proxy:true},{key:"modal-footer",fn:function(){return [_c('button',{staticClass:"button-accept btn btn-primary",on:{"click":function($event){$event.preventDefault();return close($event)}}},[_vm._v(" "+_vm._s(okLabel)+" ")])]},proxy:true}],null,true)},[_vm._v(" "+_vm._s(text)+" ")]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }